import type { ApiMeetingTips, MeetingTips } from '@api/types/meetingTips';

const adaptMeetingTips = (data: ApiMeetingTips): MeetingTips => {
  return {
    id: data.id,
    selections: data.selections.map((selection) => ({
      category: selection.category,
      raceNumber: selection.raceNumber,
      runnerNumber: selection.runnerNumber,
    })),
    professionalsToFollow: data.professionalsToFollow.map((professional) => ({
      name: professional.name,
      title: professional.title || null,
    })),
  };
};

export { adaptMeetingTips };
